import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Menu = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="menu icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M1 4.98199C1 3.87743 1.89543 2.98199 3 2.98199H21C22.1046 2.98199 23 3.87743 23 4.98199C23 6.08656 22.1046 6.98199 21 6.98199H3C1.89543 6.98199 1 6.08656 1 4.98199Z"
    />
    <path
      className={pathClass}
      d="M1 11.982C1 10.8774 1.89543 9.98199 3 9.98199H21C22.1046 9.98199 23 10.8774 23 11.982C23 13.0866 22.1046 13.982 21 13.982H3C1.89543 13.982 1 13.0866 1 11.982Z"
    />
    <path
      className={pathClass}
      d="M3 16.982C1.89543 16.982 1 17.8774 1 18.982C1 20.0866 1.89543 20.982 3 20.982H21C22.1046 20.982 23 20.0866 23 18.982C23 17.8774 22.1046 16.982 21 16.982H3Z"
    />
  </svg>
)
